import React from "react";

import { formatAmount } from "../../../helpers/format";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Rating from "../../../components/Rating";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Book({ size, item = {} }) {
    const {
        id = "",
        image,
        url = "",
        price = "",
        rating = null,
        name = "",
        author_name = "",
        total_rating = 0
    } = item;

    return (
        <div className={`${style.bookProducts} ${style[size]}`}>
            <div className={style.bookCardInner}>
                <Link to={`/book/${url}`} className={style.fullBlock}></Link>
                <div className={style.singleBookImage}>
                    <div className={style.bookImage}>
                        <Background className={style.bookCardImage} size="140x215" src={image} cPosition="bottomLeft" />
                    </div>
                </div>
                <div className={style.contentBox}>
                    {
                        price !== "" && (
                            <>
                                <Title className="fontTeko" tag="h5">{`${formatAmount(price, "£")}`}</Title>
                                <Spacer size="16" />
                            </>
                        )
                    }
                    <div className={style.bookTextContent}>
                        {
                            name !== "" && (
                                <div className={style.bookDesc}>
                                    <Title className="fontTeko" transform="uppercase" tag="h6">{name}</Title>
                                </div>
                            )
                        }
                        {
                            author_name !== "" && (
                                <div className={style.bookAuthor}>
                                    <Text text={author_name} />
                                </div>
                            )
                        }
                        <div className={style.rate}>
                            <Rating type="book" id={id} rating={rating} label={false} />
                            {
                                total_rating !== 0 && (
                                    <Title className="fontTeko" tag="p">{total_rating}</Title>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}